import s from "./add-teacher-review-modal.module.scss";
import { Modal } from "@shared/ui/modal/modal";
import { IconStar, IconStarFilled } from "@tabler/icons-react";
import { Button } from "@shared/ui/button/button";
import { useEffect, useState } from "react";
import classNames from "classnames";
import { useAddTeacherReviewModal } from "../../model/useAddTeacherReviewModal";
import { useAddTeacherReview } from "../../api/useAddTeacherReview";
import { FormProvider, useForm } from "react-hook-form";
import { ConsentBlock, ConsentCaption } from "@shared/ui/consent-block/consent-block";

export const AddTeacherReviewModal = () => {
  const { isOpen, close, modalParams } = useAddTeacherReviewModal();

  const [text, setText] = useState(modalParams?.review?.feedback_message || "");
  const [rate, setRate] = useState(modalParams?.review?.feedback_rating || 0);

  const [confidence_rating, set_confidence_rating] = useState(
    modalParams?.review?.confidence_rating || 0,
  );
  const [clarity_rating, set_clarity_rating] = useState(
    modalParams?.review?.clarity_rating || 0,
  );
  const [process_rating, set_process_rating] = useState(
    modalParams?.review?.process_rating || 0,
  );
  const [preparation_rating, set_preparation_rating] = useState(
    modalParams?.review?.preparation_rating || 0,
  );

  const stars = [1, 2, 3, 4, 5];

  const { mutate: addReview } = useAddTeacherReview();
  const methods = useForm();
  const personalDataConsent = methods.watch("personal_data_consent");

  const onAddReview = () => {
    addReview({
      body: {
        overall_rating: rate,
        message: text.trim(),
				confidence_rating: confidence_rating === 0 ? null : confidence_rating,
				clarity_rating: clarity_rating === 0 ? null : clarity_rating,
				process_rating: process_rating === 0 ? null : process_rating,
				preparation_rating: preparation_rating === 0 ? null : preparation_rating,
      },
      id: modalParams?.teacher_id,
    });
    close();
  };

  useEffect(() => {
    if (!isOpen) {
      setText("");
      setRate(0);
      set_confidence_rating(0);
      set_clarity_rating(0);
      set_process_rating(0);
      set_preparation_rating(0);
      methods.reset();
    }
  }, [isOpen, methods]);

  const handleAddReview = methods.handleSubmit(() => {
    onAddReview();
  });

  return (
    <Modal {...{ isOpen, close }} title={"Как все прошло?"}>
      <FormProvider {...methods}>
        <div className={s.card}>
          <div className={s.rateWrapper}>
            <div className={s.reviewTitle}>Общая оценка</div>
            <div className={s.rate}>
              {stars.map((item) => (
                <button
                  type="button"
                  className={s.starButton}
                  onClick={() => setRate(item)}
                  key={item}
                >
                  {item <= rate ? (
                    <IconStarFilled className={s.starActive} />
                  ) : (
                    <IconStar className={s.star} />
                  )}
                </button>
              ))}
            </div>
          </div>
          <div className={s.specialReviewsList}>
            <h3 className={s.specialsReviewsTitle}>Похвала преподавателю</h3>
            <div className={s.specialReviewWrapper}>
              <div className={s.specialReviewLabel}>
                <img
                  src={
                    process.env.REACT_APP_STORAGE_URL +
                    "images/teacher-page/stars.png"
                  }
                  alt=""
                  className={s.specialReviewImage}
                />
                Уверенность
              </div>
              <VariantsButtons value={confidence_rating} onChange={set_confidence_rating}/>
            </div>
            <div className={s.specialReviewWrapper}>
              <div className={s.specialReviewLabel}>
                <img
                  src={
                    process.env.REACT_APP_STORAGE_URL +
                    "images/teacher-page/user-music.png"
                  }
                  alt=""
                  className={s.specialReviewImage}
                />
                Ясность
              </div>
              <VariantsButtons value={clarity_rating} onChange={set_clarity_rating}/>
            </div>
            <div className={s.specialReviewWrapper}>
              <div className={s.specialReviewLabel}>
                <img
                  src={
                    process.env.REACT_APP_STORAGE_URL +
                    "images/teacher-page/disk-music.png"
                  }
                  alt=""
                  className={s.specialReviewImage}
                />
                Процесс
              </div>
              <VariantsButtons value={process_rating} onChange={set_process_rating}/>
            </div>
            <div className={s.specialReviewWrapper}>
              <div className={s.specialReviewLabel}>
                <img
                  src={
                    process.env.REACT_APP_STORAGE_URL +
                    "images/teacher-page/music.png"
                  }
                  alt=""
                  className={s.specialReviewImage}
                />
                Подготовка
              </div>
              <VariantsButtons value={preparation_rating} onChange={set_preparation_rating}/>
            </div>
          </div>
          <div className={s.areaWrapper}>
            <div className={s.areaTitle}>Ваш отзыв</div>
            <textarea
              className={s.textarea}
              placeholder="Текст..."
              value={text}
              onChange={(e) => setText(e?.currentTarget?.value)}
            />
          </div>
          <ConsentBlock className={s.consentBlock} showPublicationConsent showUserAgreementCaption={false}/>
          <Button
            disabled={!rate || !personalDataConsent}
            className={s.btn}
            onClick={handleAddReview}
            label={"Отправить"}
          />
          <ConsentCaption className={s.consentCaption}/>
        </div>
      </FormProvider>
			
    </Modal>
  );
};

const VariantsButtons = ({ value, onChange }) => {
  return (
    <div className={s.specialsReviewVariants}>
      <button
        type="button"
        className={classNames(
          s.specialsReviewVariantButton,
          +value === 3 ? s.active : "",
        )}
        onClick={() => {
          if (+value !== 3) onChange(3);
        }}
      >
        Плохо
      </button>
      <button
        type="button"
        className={classNames(
          s.specialsReviewVariantButton,
          +value === 4 ? s.active : "",
        )}
        onClick={() => {
          if (+value !== 4) onChange(4);
        }}
      >
        Нормально
      </button>
      <button
        type="button"
        className={classNames(
          s.specialsReviewVariantButton,
          +value === 5 ? s.active : "",
        )}
        onClick={() => {
          if (+value !== 5) onChange(5);
        }}
      >
        Отлично
      </button>
    </div>
  );
};
